/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiGroupHoursFromJSON, StreemApiGroupHoursToJSON, } from './';
export function StreemApiGroupFromJSON(json) {
    return StreemApiGroupFromJSONTyped(json, false);
}
export function StreemApiGroupFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'sid': !exists(json, 'sid') ? undefined : json['sid'],
        'imageUrl': !exists(json, 'image_url') ? undefined : json['image_url'],
        'workingHoursByDay': !exists(json, 'working_hours_by_day') ? undefined : (json['working_hours_by_day'].map(StreemApiGroupHoursFromJSON)),
    };
}
export function StreemApiGroupToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'description': value.description,
        'sid': value.sid,
        'image_url': value.imageUrl,
        'working_hours_by_day': value.workingHoursByDay === undefined ? undefined : (value.workingHoursByDay.map(StreemApiGroupHoursToJSON)),
    };
}
//# sourceMappingURL=StreemApiGroup.js.map